import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Breadcrumbs.css';

/**
 * Breadcrumbs — хлебные крошки.
 *
 * Props:
 *   items - [{ label, path? }] — последний элемент без path = текущая страница
 */
export function Breadcrumbs({ items = [], className = '' }) {
  const navigate = useNavigate();

  if (items.length <= 1) return null;

  return (
    <nav className={`ui-breadcrumbs ${className}`} aria-label="Навигация">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && <ChevronRight size={14} className="ui-breadcrumbs__sep" />}
            {isLast || !item.path ? (
              <span className={`ui-breadcrumbs__item ${isLast ? 'ui-breadcrumbs__item--current' : ''}`}>
                {item.label}
              </span>
            ) : (
              <button
                className="ui-breadcrumbs__item ui-breadcrumbs__item--link"
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
